import type { VirtualAppointmentTeam } from '../../services/virtualAppointments';
import { getTeamColor } from '@odo/shared-ui/components/teamColors';
import type { SegmentedOption } from './SegmentedToggle';

// Same source and treatment as TeamPill: hex background with white text, a white/40 dot when
// selected, and a dot in the team colour while unselected.
export function teamSegmentOption<T extends string>(
    team: VirtualAppointmentTeam,
    value: T
): SegmentedOption<T> {
    const color = getTeamColor(team);
    return {
        value,
        label: team,
        selectedClassName: 'text-white font-semibold shadow-sm',
        selectedStyle: { backgroundColor: color },
        leading: (selected: boolean) => (
            <span
                aria-hidden="true"
                className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${selected ? 'bg-white/40' : ''}`}
                style={selected ? undefined : { backgroundColor: color }}
            />
        )
    };
}
